import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-pwc-brand',
  templateUrl: './pwc-brand.component.html',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PwcBrandComponent {
  get logoPath(): string {
    return 'assets/images/login/pwc_logo_positive.png';
  }
}
